import React from 'react'
import { TextField } from '@material-ui/core';

export default function Input(props) {

    const { name, label, value,error=null, onChange,defaultMessage,readOnly = false,
        disabled = false, inputProps, ...otherProps} = props;
    return (<>
        <TextField
            variant="outlined"
            label={label}
            name={name}
            value={value}
            onChange={onChange}
            disabled={disabled}
            {...(error && {error:true,helperText:error})}
            {...(defaultMessage&& {required: true})}
            inputProps={inputProps}
            InputProps={{
                readOnly: readOnly,
                ...((readOnly || disabled) && {
                    style: { 
                        backgroundColor: '#f5f5f5',
                        cursor: 'not-allowed'
                    }
                }),
                ...otherProps.InputProps
            }}
            {...otherProps}
        />
        {/*{!error && defaultMessage &&<div style={{color: "#f44336", marginLeft: '23px', fontSize: "0.75rem", marginTop:'-5px'}} className={"MuiFormControl-root MuiTextField-root"}>{defaultMessage}</div>}*/}
        </>
    )
}
